import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=0cfa9e99&scoped=true"
import script from "./Notfound.vue?vue&type=script&lang=js"
export * from "./Notfound.vue?vue&type=script&lang=js"
import style0 from "./Notfound.vue?vue&type=style&index=0&id=0cfa9e99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa9e99",
  null
  
)

export default component.exports